import React from 'react'

import Button from '@react/react-spectrum/Button'
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger'
import Popover from '@react/react-spectrum/Popover'

import Info from '@react/react-spectrum/Icon/Info'

import './FieldInfo.scss'

const FieldInfo = ({ title, icon = <Info />, children }) => (
  <OverlayTrigger placement='right'>
    <Button
      variant='tool'
      icon={icon}
      className='field-info-button'
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()
      }}
    />
    <Popover title={title}>{children}</Popover>
  </OverlayTrigger>
)

export default FieldInfo
